import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BusinessCardRecord } from './app.types';

@Component({
  selector: 'app-business-card-history',
  standalone: false,
  template: `
    <section class="history" *ngIf="visible">
      <div class="history-header">
        <h2>Your Business Cards</h2>
      </div>

      <ion-note color="medium" *ngIf="isLoading">Loading business cards...</ion-note>
      <ion-note color="medium" *ngIf="!isLoading && businessCards.length === 0">No saved business cards yet.</ion-note>

      <div class="qr-list" *ngIf="businessCards.length > 0">
        <div
          class="qr-list-item"
          *ngFor="let businessCard of businessCards"
          [class.active]="selectedBusinessCardId === businessCard.id"
        >
          <button type="button" class="qr-list-main" (click)="selectBusinessCard.emit(businessCard)">
            <span class="qr-title">{{ businessCard.name }}</span>
            <span class="qr-target">{{ businessCard.company || businessCard.email || businessCard.website }}</span>
            <span class="qr-meta">{{ businessCard.qr_code ? 'QR attached' : 'No QR attached' }}</span>
          </button>
          <span class="qr-actions">
            <button
              type="button"
              class="qr-inline-action danger"
              [disabled]="deletingBusinessCardId === businessCard.id"
              (click)="deleteBusinessCard.emit(businessCard)"
            >
              {{ deletingBusinessCardId === businessCard.id ? 'Deleting...' : 'Delete' }}
            </button>
          </span>
        </div>
      </div>
    </section>
  `
})
export class BusinessCardHistoryComponent {
  @Input() visible = false;
  @Input() businessCards: BusinessCardRecord[] = [];
  @Input() selectedBusinessCardId: number | null = null;
  @Input() deletingBusinessCardId: number | null = null;
  @Input() isLoading = false;

  @Output() selectBusinessCard = new EventEmitter<BusinessCardRecord>();
  @Output() deleteBusinessCard = new EventEmitter<BusinessCardRecord>();
}
